import styled from "styled-components";

export type SearchFieldProps = {
    query: string,
    setQuery: (query: string) => void,
};

export const SearchInput = styled.input`
    width: 23rem;
    border: none;
    border-radius: 0.625rem;
    font-size: 1rem;
    color: ${props => props.theme.palette.common.black};
    background-color: ${props => props.theme.palette.primary.light};
    outline-color: ${props => props.theme.palette.primary.medium};
    outline-width: thin;
    padding: 0.5rem;
    font-family: ${props => props.theme.fontFamily};

    &::placeholder {
        color: white;
        opacity: 1;
    }

    &::-ms-input-placeholder { /* Edge 12 -18 */
        color: white;
    }

    /* Phones */
    @media only screen and (max-width: 767px) {
        width: 16rem;
    }
`;

function SearchField(props: SearchFieldProps) {

    const {query, setQuery} = props;

    return (
        <SearchInput
            type="text"
            placeholder={"Search for a track name"}
            onChange={(event) => setQuery(event.target.value)}
            value={query}/>
    );
}

export default SearchField;
